import { z } from 'zod';

/**
 * Reusable field schemas for form validation
 * Messages updated to use translation keys
 */

export const nameSchema = z
    .string()
    .min(1, "errors.nameRequired")
    .max(100, "errors.nameTooLong")
    .trim();

export const ageSchema = z
    .string()
    .min(1, "errors.ageRequired")
    .refine((val) => !isNaN(Number(val)), "errors.ageNaN")
    .refine((val) => Number(val) > 0 && Number(val) <= 200, "errors.ageRange")
    .transform((val) => Number(val));

export const genderSchema = z
    .union([
        z.enum(["Male", "Female", "Non Binary"]),
        z.literal("")
    ])
    .refine((val) => val !== "" && val !== null && val !== undefined, {
        message: "errors.genderRequired"
    });

export const dateSchema = z
    .string()
    .nullable()
    .refine((val) => val !== null && val !== "", "errors.dateRequired")
    .refine((val) => !val || !isNaN(Date.parse(val)), "errors.invalidDate");

export const timeSchema = z
    .string()
    .nullable()
    .refine((val) => val !== null && val !== "", "errors.timeRequired")
    .refine((val) => !val || /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(val), "errors.invalidTime");

export const optionalTextSchema = z
    .string()
    .trim()
    .optional()
    .or(z.literal(""));
